<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'500px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="">
        <h3 class="dialogTitle">Từ chối ban hành văn bản</h3>
        <el-form label-position="top" ref="form" :model="form" :rules="rules">
          <el-form-item label="Lý do từ chối" prop="content">
            <el-input
              v-model="form.content"
              type="textarea"
              rows="5"
              placeholder="_"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action margin-top-10">
        <el-button
          type="success"
          size="mini"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="banHanh"
          :disabled="isProcessing"
        >
          <span>
            <i :class="[!isProcessing ? 'far fa-check-circle font-size__small' : 'el-icon-loading']"></i>
            &nbsp;Xác nhận
          </span>
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
import vbFlowInstanceService from "../../../services/vbFlowInstanceService";
import {EventBus} from "../../../event-bus";

export default {
  name: "DocOutTuChoi",

  props: ["docId", "isOpen"],
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue")
  },
  data() {
    return {
      flowInstanceId: null,
      form: { content: null },
      rules: {
        content: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ]
      },
      isProcessing: false
    };
  },

  methods: {
    banHanh() {
      this.$refs.form.validate(valid => {
        if (!valid) return;

        this.isProcessing = true;
        vbFlowInstanceService
          .findAll(
            { docId: this.docId },
            { page: 0, size: 1, sort: "updateTime,desc" }
          )
          .then(response => {
            this.flowInstanceId = response.data[0].id;

            let submitForm = {
              flowInstanceId: this.flowInstanceId,
              content: this.form.content
            };

            vbOutgoingProcessService
              .tuChoiBanHanh(submitForm, this.docId)
              .then(() => {
                this.message(
                  "Thông báo",
                  "Từ chối văn bản ban hành thành công.",
                  "success",
                  3000
                );
                EventBus.$emit('loadCounting', '');
                this.$emit("tuChoiSuccess");
                this.isProcessing = false;
              })
              .catch(error => {
                this.commonHandleRequestError(error);
                this.isProcessing = false;
              });
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            this.isProcessing = false;
          });
      });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/DocOutTuChoiBHanh.vue